if (!customElements.get('ja-roi-calculator')) {
  customElements.define('ja-roi-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.form = this.querySelector('[data-roi-form]');
      this.dialog = this.querySelector('dialog');
      this.panel = this.querySelector('[data-roi-panel]');
      this.period = this.period || 'yearly';
      this.format = window.JaEvoMath.money(this.dataset.currency);
      if (this.dataset.mode === 'popup' && typeof this.dialog.showModal === 'function') {
        this.dialog.append(this.panel);
        this.querySelector('[data-roi-inline]').hidden = true;
        this.querySelector('[data-roi-trigger-wrapper]').hidden = this.dataset.showTrigger !== 'true';
        this.querySelector('[data-roi-open]').addEventListener('click', event => this.open(event.currentTarget), options);
        document.addEventListener('click', event => {
          const link = event.target.closest('a[href]');
          if (!link || link.getAttribute('href') !== `#${this.id}`) return;
          event.preventDefault();
          this.open(link);
        }, options);
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:section:select', event => {
            if (event.target.contains(this)) this.open();
          }, options);
          document.addEventListener('shopify:section:deselect', event => {
            if (event.target.contains(this)) this.dialog.close();
          }, options);
        }
      }
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.form.reportValidity()) this.calculate();
      }, options);
      this.form.addEventListener('input', () => {
        this.updateSteppers();
        if (this.form.checkValidity()) this.calculate();
      }, options);
      this.form.addEventListener('click', event => {
        const button = event.target.closest('[data-roi-step]');
        if (!button) return;
        const input = button.closest('.ja-roi__quantity').querySelector('input');
        if (button.dataset.roiStep === '1') input.stepUp();
        else input.stepDown();
        if (input.name === 'wage' && Number.isFinite(input.valueAsNumber)) {
          input.value = input.valueAsNumber.toFixed(2);
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }, options);
      this.querySelectorAll('[data-period]').forEach(button => {
        button.addEventListener('click', () => {
          if (!this.form.reportValidity()) return;
          this.period = button.dataset.period;
          this.querySelectorAll('[data-period]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.calculate();
        }, options);
      });
      this.querySelector('[data-roi-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restoreFocus(), options);
      this.updateSteppers();
      this.calculate();
    }
    updateSteppers() {
      this.form.querySelectorAll('.ja-roi__quantity').forEach(control => {
        const input = control.querySelector('input');
        control.querySelector('[data-roi-step="-1"]').disabled = input.value !== '' && input.valueAsNumber <= Number(input.min);
        control.querySelector('[data-roi-step="1"]').disabled = input.value !== '' && input.valueAsNumber >= Number(input.max);
      });
    }
    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener || document.activeElement;
      this.period = 'yearly';
      this.querySelectorAll('[data-period]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.period === this.period)));
      this.calculate();
      this.dialog.showModal();
      this.form.elements.employees.focus();
    }
    restoreFocus() {
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      this.opener = null;
    }
    calculate() {
      if (this.form.checkValidity()) this.lastValidValues = Object.fromEntries(new FormData(this.form));
      const values = this.lastValidValues;
      if (!values) return;
      const result = window.JaEvoMath.lostTime({
        employees: Number(values.employees), wage: Number(values.wage), minutes: Number(values.minutes),
        workingDays: Number(this.dataset.workingDays), daysPerWeek: Number(this.dataset.daysPerWeek), period: this.period
      });
      this.querySelector('[data-roi-hours]').textContent = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(result.hours);
      this.querySelector('[data-roi-cost]').textContent = this.format.format(result.cost);
      this.querySelector('[data-roi-period-label]').textContent = this.querySelector(`[data-period="${this.period}"]`).textContent;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreFocus();
      this.events?.abort();
      this.events = null;
    }
  });
}
